<form class="itinerary-model-content-inner"  [formGroup]="visaDetailsForm">
  <div class="itinerary-model-content">
    <div class="ion-no-padding">
      <ion-title class="dark-title-sm ion-padding-horizontal py-1 bg-light-gray">Lead Information</ion-title>
    </div>
    <div class="form-container ion-padding-horizontal">
      <div class="destinations-days-row row">
        <div class="col-4" >
          <div class="input-container">
            <label for="" class="label">Destination*</label>
            <div [ngClass]="{ 'invalid-input': visaDetailsForm.get('destination')?.invalid && visaDetailsForm.get('destination')?.touched }">
              <app-countries-dropdown-input formControlName="destination"></app-countries-dropdown-input>
            </div>
          </div>
          
        </div>

        <div class="col-2">
          <div class="input-container">
            <label for="" class="label">Duration (Days)</label>
            <div [ngClass]="{ 'invalid-input': visaDetailsForm.get('nights')?.invalid && visaDetailsForm.get('nights')?.touched }">
              <app-increment-number-input formControlName="nights" [max]="365"></app-increment-number-input>
            </div>
          </div>
        </div>
      </div>
      
  
      <div class="row">
        <div class="col-3">
          <div class="input-container">
            <label for="" class="label" >Trip Start date</label>
            <div [ngClass]="{ 'invalid-input': visaDetailsForm.get('startDate')?.invalid && visaDetailsForm.get('startDate')?.touched }">
              <app-date-picker [minDate]="today" formControlName="startDate"></app-date-picker>
            </div>
          </div>
        </div>
        <div class="col-3">
          <div class="input-container">
            <label for="" class="label" >Trip end date</label>
            <div [ngClass]="{ 'invalid-input': visaDetailsForm.get('endDate')?.invalid && visaDetailsForm.get('endDate')?.touched }">
              <app-date-picker [minDate]="today" [isDisabled]="true" formControlName="endDate"></app-date-picker>
            </div>
          </div>
        </div>
        <div class="col-6">
          <div class="input-container">
             <label for="" class="label">No Of Passengers <span class="text-danger warning-message" *ngIf="visaDetailsForm.get('totalAdults')?.invalid && visaDetailsForm.get('totalAdults')?.touched ">Adults cannot be 0</span></label>
            <div class="d-flex align-items-end" [ngClass]="{ 'invalid-input': visaDetailsForm.get('totalPassengers')?.invalid && visaDetailsForm.get('totalPassengers')?.touched }">
              <app-increment-number-input formControlName="totalPassengers" [max]="1000" [min]="1"></app-increment-number-input>
              <p class="passenger-count">{{visaDetailsForm.get('totalAdults')?.value}} Adults | {{visaDetailsForm.get('totalChildrens')?.value}} Children</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Passenger grid start -->
    <div class="my-2">
      <ion-title class="dark-title-sm ion-padding-horizontal py-1 bg-light-gray">Passenger's Personal Information</ion-title>
    </div>
    <div class="form-container">
      <div class="ion-padding-horizontal">
        <div *ngIf="passengerInfoArray().invalid && passengerInfoArray().touched" class="text-danger" style="font-size: 12px;">
          Please fill out all required fields in the passenger information.
        </div>
        <table class="table table-bordered invoice-items-table">
          <thead>
            <tr>
              <!-- <th class="sm-column">S No.</th> -->
              <th>First Name</th>
              <th>Last Name</th>
              <th>DOB</th>
              <th class="md-column">Age</th>
              <th>Gender</th>
              <th>Nationality</th>
              <th>Visa Type</th>
              <th>Applicant</th>
            </tr>
          </thead>
          <tbody formArrayName="passengerInfo">
            <tr *ngFor="let item of passengerInfoArray().controls; let i = index" [formGroupName]="i">
              <td [ngClass]="{'empty-field':checkTableCellEmpty('firstName', i)}">
                <input class="table-input" formControlName="firstName" [appMaxLength]="50">
              </td>
              <td [ngClass]="{'empty-field':checkTableCellEmpty('lastName', i)}">
                <input type="text" class="table-input" formControlName="lastName" [appMaxLength]="50">
              </td>
              <td [ngClass]="{'empty-field':checkTableCellEmpty('dateOfBirth', i)}">
                <app-date-picker formControlName="dateOfBirth" [maxDate]="today"></app-date-picker>
              </td>
              <td [ngClass]="{'empty-field':checkTableCellEmpty('age', i)}">
                <input type="text" readonly class="table-input" formControlName="age">
              </td>
              <td [ngClass]="{'empty-field':checkTableCellEmpty('gender', i)}">
                <select formControlName="gender" class="input table-input">
                  <option value="" hidden>- gender -</option>
                  <option value="Male">Male</option>
                  <option value="Female">Female</option>
                  <option value="Others">Others</option>
                  <option value="Prefer not to say">Prefer not to say</option>
                </select>
              </td>
              <td [ngClass]="{'empty-field':checkTableCellEmpty('nationality', i)}">
                <app-dropdown-select [dropdownValues]="nationality" formControlName="nationality"></app-dropdown-select>
              </td>
              <td [ngClass]="{'empty-field':checkTableCellEmpty('visaType', i)}">
                <select formControlName="visaType" class="input table-input">
                  <option value="" hidden>- visa type -</option>
                  <option *ngFor="let type of visaTypes" [value]="type.key">{{ type.name }}</option>
                </select>
              </td>
              <td [ngClass]="{'empty-field':checkTableCellEmpty('applicantType', i)}">
                <select formControlName="applicantType" class="input table-input">
                  <option value="" hidden>- applicant type -</option>
                  <option *ngFor="let type of applicantTypes" [value]="type.key">{{ type.name }}</option>
                </select>
              </td>
            </tr>
            <tr *ngIf="passengerInfoArray().length === 0">
              <td colspan="8" class="text-center">
                <p class="my-2">No Passengers Added!</p>
              </td>
            </tr>
          </tbody>
          
        </table>
      </div>
    </div>
    <!-- Passenger grid end -->

    <div class="ion-padding-horizontal">
      <div class="row">
        <div class="col">
          <div class="input-container">
            <label for="" class="label">Note</label>
            <div [ngClass]="{ 'invalid-input': visaDetailsForm.get('note')?.invalid && visaDetailsForm.get('note')?.touched }">
              <textarea formControlName="note" name="" id="" class="input" placeholder="itinerary Notes"></textarea>
            </div>
          </div>
        </div>
      </div>
    </div>
    

  </div>
  
  <div class="ion-padding-horizontal bg-light-gray justify-content-center itinerary-model-footer">
    <ion-button class="unfilled-blue-btn" (click)="goPrevious()" [disabled]="formDataModified()">
      <ion-icon slot="icon-only" name="chevron-back-outline"></ion-icon>
    </ion-button>
    <ion-button class="unfilled-blue-btn" (click)="resetForm()" [disabled]="!formDataModified()">
      Reset
    </ion-button>
    <ion-button class="filled-blue-btn" (click)="onSubmit()" [disabled]="!formDataModified()">
      Save
    </ion-button>
    <ion-button class="filled-blue-btn" (click)="saveAndNext()" [disabled]="!formDataModified()">
      Save & Next
    </ion-button>
    <ion-button class="unfilled-blue-btn" (click)="goNext()" [disabled]="!visaId || formDataModified()">
      <ion-icon slot="icon-only" name="chevron-forward-outline"></ion-icon>
    </ion-button>
  </div>
</form>


